export class TypeOuiNon {

	public oui: Boolean;
	public non: Boolean;

	constructor(){
		this.oui = true;
		this.non = false;
	}
}
